// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__oM3K1","colMin":"styles_colMin__2JHml"};